import styled from "styled-components"
import appendCDN from "~/utils/append_cdn_link"

interface Props {
  size?: number
  src?: string
}

const Avatar = styled.div<Props>`
  display: inline-block;
  width: ${p => p.size || 30}px;
  height: ${p => p.size || 30}px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${p => p.src || appendCDN('/img/account.svg')});
`

export default Avatar